/**
 * The interval in milliseconds to send a heartbeat for a single livestream to the server.
 */
export const HEARTBEAT_SEND_INTERVAL = 5000;
